import React from 'react'
import { LocalizedLink, useTranslation } from '../lib/i18n'
import styled from 'styled-components'
import { FaFacebook } from 'react-icons/fa'
import { FACEBOOK_URL } from '../lib/product'

const Wrapper = styled.div`
    border-top: 1px solid ${(props) => props.theme.palette.greyScale.lighterGrey};
    margin-top: 20px;
    padding-top: 20px;
    padding-bottom: 20px;

    hr {
    }
    p.copyright {
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .social {
        display: inline-flex;
        color: ${(props) => props.theme.palette.greyScale.grey};
        font-size: 18px;
        transition: color 0.2s ease;

        &:hover {
            color: #1877f2;
        }
    }
    .button {
        font-size: 13px;
        padding: 0px;
        &:not(:last-child) {
            margin-right: 20px;
        }
    }
`

export default () => {
    const { t } = useTranslation(undefined, { keyPrefix: 'footer' })

    return (
        <Wrapper className="grid-container">
            <div className="grid-x align-justify">
                <div className="cell small-12 medium-auto">
                    <p className="copyright">
                        Keybreak · 2026
                        <a className="social" href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label={t('facebook')}>
                            <FaFacebook />
                        </a>
                    </p>
                </div>
                <div className="cell shrink">
                    <LocalizedLink className="button clear primary" to="/break-reminder-app">
                        {t('breakReminderApp')}
                    </LocalizedLink>
                    <LocalizedLink className="button clear primary" to="/changelog">
                        {t('changelog')}
                    </LocalizedLink>
                    <LocalizedLink className="button clear primary" to="/privacy">
                        {t('privacy')}
                    </LocalizedLink>
                    <LocalizedLink className="button clear primary" to="/eula">
                        {t('eula')}
                    </LocalizedLink>
                </div>
            </div>
        </Wrapper>
    )
}
